<template>
  <ul class="dashboard-list color-coded">
    <li v-if="listType === 'student'" class="row header-labels">
      <div class="col-6 subject">
        <skeleton width="50px" height="16px" />
      </div>
      <div class="col-6 data">
        <skeleton width="40px" height="16px" />
      </div>
    </li>
    <li
      v-for="n in listItems"
      :key="n"
      :style="listType === 'student' && 'min-height: 83px'"
    >
      <div class="col-9 subject">
        <div class="avatars hide-sm-down">
          <template v-if="listType === 'session'">
            <skeleton width="30px" height="30px" radius="15px" />
            <skeleton width="30px" height="30px" radius="15px" />
          </template>
          <template v-else>
            <skeleton width="40px" height="40px" radius="20px" />
          </template>
        </div>
        <div>
          <div class="primary">
            <skeleton width="175px" height="14px" />
          </div>
          <div class="secondary">
            <skeleton width="160px" height="14px" />
            <skeleton
              v-if="listType === 'student'"
              width="120px"
              height="14px"
              style="display: block"
            />
          </div>
        </div>
      </div>
      <div class="col-3 data right-align">
        <div class="status">
          <skeleton width="80px" height="14px" />
        </div>
        <skeleton width="20px" height="14px" style="margin-left: 15px" />
      </div>
    </li>
  </ul>
</template>

<script>
import Skeleton from './Skeleton.vue';

export default {
  name: 'ListSkeleton',

  components: {
    Skeleton
  },

  props: {
    listItems: {
      type: Number,
      default: () => 5
    },
    listType: {
      type: String,
      default: () => ''
    }
  }
};
</script>
